import { Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  configData: any;

  constructor(private user: UserService) { }

  updateConfig(configLinks: any) {
    this.configData = configLinks.map((el: any) => {
      if (Object.hasOwn(el, 'isActive')) {
        el.isActive = this.isAccessible(el.accessIds);
      }
      if (Object.hasOwn(el, 'customerAssistanceTools')) {
        el.customerAssistanceTools.map((cat: any) => {
          if (cat.subMenuId === 'whyzenEmployerReporting') {
            cat.hasAccess = this.isAccessible(cat.accessIds, cat) && this.user.getAccessLevels.length > 0;
          } else {
            cat.hasAccess = this.isAccessible(cat.accessIds, cat);
          }
          if (cat.subPrivilege && cat.subPrivilege.length > 0) {
            cat.subPrivilege.map((sub: any) => {
              sub.hasAccess = this.isAccessible(sub.accessIds, sub);
            });
          }
        });
      }
      if (Object.hasOwn(el, 'adminTools')) {
        el.adminTools.map((at: any) => {
          if (at.subMenuId === 'whyzenEmployerReporting') {
            at.hasAccess = this.isAccessible(at.accessIds, at) && this.user.getAccessLevels.length > 0;
          } else {
            at.hasAccess = this.isAccessible(at.accessIds, at);
          }
          if (at.subPrivilege && at.subPrivilege.length > 0) { 
            at.subPrivilege.map((sub: any) => {
              sub.hasAccess = this.isAccessible(sub.accessIds, sub);
            });
          }
        });
      }
      return el;
    })
  }

  isAccessible(accessIds: string[], configValue?: any) {
    const roles = accessIds.filter(con => con.startsWith('ROLE'));
    const privileges = accessIds.filter(con => con.startsWith('PRIV'));
    const hasRole = roles.includes(this.user.userRole);
    let hasPrivilege = privileges.some(priv => this.user.userPrivilegesList.includes(priv));
    if (configValue?.subMenuId === 'searchUser' || configValue?.subMenuId === 'createOrModifyUser' || configValue?.subMenuId === 'spoofUser'
      || configValue?.subMenuId === 'loginToSelfFundedPortal'
      || configValue?.subMenuId === 'externalNotifications'
      || configValue?.subMenuId === 'userDashboard'
      || configValue?.subMenuId === 'authorizationWithClinicalNotes'
      || configValue?.subMenuId === 'accounting'
    ) {
      hasPrivilege = privileges.every(priv => this.user.userPrivilegesList.includes(priv));
    }
    if (configValue?.subMenuId === 'createExternalReportingAdmin' || configValue?.subMenuId === 'manageProducerUser'
      || configValue?.subMenuId === 'brokerConnection' || configValue?.subMenuId === 'createNewBrokerAnalyst' || configValue?.subMenuId === 'generateUrlMedicare'
      || configValue?.subMenuId === 'directDepositReport' || configValue?.subMenuId === 'generateBrokerReports' || configValue?.subMenuId === 'openAdminTool') {
      return this.user.isAuthenticated && this.user.isAccountInfoAvailable && (hasRole && hasPrivilege);
    } else if (configValue?.subMenuId === 'searchUser' || configValue?.subMenuId === 'createOrModifyUser' || configValue?.subMenuId === 'spoofUser'
      || configValue?.subMenuId === 'loginToSelfFundedPortal'
      || configValue?.subMenuId === 'externalNotifications'
      || configValue?.subMenuId === 'userDashboard'
      || configValue?.subMenuId === 'authorizationWithClinicalNotes'
      || configValue?.subMenuId === 'accounting') {
      return this.user.isAuthenticated && this.user.isAccountInfoAvailable && hasPrivilege;
    } else if (configValue?.subMenuId === 'noneProspect') {
      return this.user.isAuthenticated && !hasRole || !hasPrivilege;
    } else if (configValue?.subMenuId === 'healthcareSpendingReport' && (this.user.userRole != 'ROLE_SUPER_ADMIN')) {
      return this.user.isAuthenticated && this.user.isAccountInfoAvailable && (hasRole && hasPrivilege);
    } else {
      return this.user.isAuthenticated && this.user.isAccountInfoAvailable && (hasRole || hasPrivilege);
    }
  }

}
